import Icon from "../common/Icon";
import styles from "./MapKeywordItem.module.css";

interface MapKeywordItemProps {
    title: string;
    size?: string;
}

const MapKeywordItem = (props: MapKeywordItemProps) => {
    return (
        <span className={styles.item}>
            <Icon name="hashtag" size={props.size? props.size : "small"} color="default" />
            {props.title}
        </span>
    );
};

export default MapKeywordItem;
